import { AfterViewInit, Component, ElementRef, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Subject, BehaviorSubject, takeUntil, map, combineLatest, startWith } from 'rxjs';
import { StoreService } from 'src/app/services/store.service';
import { OpenOrdersResponse } from 'src/app/Interfaces/SQL-reports-responses';

@Component({
	selector: 'app-open-orders-report',
	templateUrl: './open-orders-report.component.html',
	styleUrls: ['./open-orders-report.component.scss'],
})
export class OpenOrdersReportComponent implements OnInit, OnDestroy, AfterViewInit {
	private _ss = inject(StoreService);
	private fb = inject(FormBuilder);
	constructor() {}

	form = this.fb.nonNullable.group({
		search: [''],
	});

	pageMode$ = new BehaviorSubject<'open-orders' | 'open-orders-admin'>('open-orders');

	openedOrderSelected$ = new BehaviorSubject<OpenOrdersResponse[] | null>(null);
	shouldDisplayPopup$ = this.openedOrderSelected$.pipe(map(val => !!val?.length));

	openOrders$ = new BehaviorSubject<OpenOrdersResponse[]>([]);
	openOrdersDisplay$ = combineLatest([this.openOrders$, this.form.controls.search.valueChanges.pipe(startWith(''))]).pipe(
		map(([orders, search]) => {
			if (!search) {
				return orders;
			}

			return orders.filter(order => {
				return order.ClientName.includes(search) || order.ClientId.includes(search) || order.OrderNum.includes(search);
			});
		}),
		map(orders =>
			Object.values(
				orders.reduce((acc, order) => {
					acc[order.OrderNum] ||= [];
					acc[order.OrderNum].push(order);

					return acc;
				}, {} as Record<string, OpenOrdersResponse[]>),
			),
		),
	);
	totalDisplayed$ = this.openOrdersDisplay$.pipe(map(orders => orders.length));
	destroy$: Subject<void> = new Subject();

	title$ = this.pageMode$.pipe(
		map(mode => {
			switch (mode) {
				case 'open-orders':
				case 'open-orders-admin':
					return 'תעודות שלא סופקו';

				default:
					return '';
			}
		}),
	);

	@ViewChild('thead') thead: ElementRef<HTMLTableSectionElement>;
	@ViewChild('dynamicHeightTBody') dynamicHeightTBody: ElementRef<HTMLTableSectionElement>;
	@ViewChild('header') header: ElementRef<HTMLElement>;

	ngOnInit(): void {
		if (location.pathname.includes('admin')) {
			this.pageMode$.next('open-orders-admin');
		}

		this.fetchOpenOrders();
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	ngAfterViewInit(): void {
		const thead = this.thead.nativeElement;
		const tbody = this.dynamicHeightTBody.nativeElement;
		const header = this.header.nativeElement;

		if (!thead || !tbody || !header) return;

		const zoom = num => (window.innerWidth > 767 && window.innerWidth < 1100 ? num / 1.5 : num);

		tbody.style.setProperty('--dynamic-height', `${zoom(window.innerHeight - thead.clientHeight - header.clientHeight)}px`);
	}

	goBack() {
		history.back();
	}

	restart() {
		location.reload();
	}

	togglePopupState(order: OpenOrdersResponse[] | null = null) {
		this.openedOrderSelected$.next(order);
	}

	fetchOpenOrders() {
		let agent: string;
		if (this.pageMode$.value === 'open-orders') {
			agent = this._ss.AgentIdConnected || localStorage.getItem('AgentId');
		}

		this._ss
			.getOpenedOrders({ agentId: agent })
			.pipe(takeUntil(this.destroy$))
			.subscribe({
				next: res => {
					if (typeof res === 'string') {
						alert('לא ניתן להביא נתונים מהשרת');
						this.goBack();
						return;
					}

					this.openOrders$.next(res.recordset);
				},
				error: err => {
					console.error(err);
				},
			});
	}
}
